import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { isPluginAvailable } from 'src/utils/store/isPluginAvailable';
import {
    CALLS_PLUGIN,
    FB_PLUGIN,
    MAILING_PLUGIN,
    WSP_PLUGIN,
} from 'src/constants/plugins';
import { authorize } from 'src/utils/auth';
import {
    ADMIN_LEVEL_ACCESS,
    DEVELOPER_LEVEL_ACCESS,
    GROUP_LEVEL_ACCESS,
    USER_LEVEL_ACCESS,
} from './access';

const rolesArray = {
    rockstar: DEVELOPER_LEVEL_ACCESS,
    'super admin': GROUP_LEVEL_ACCESS,
    admin: ADMIN_LEVEL_ACCESS,
    user: USER_LEVEL_ACCESS,
    marketing: ADMIN_LEVEL_ACCESS,
    receptionist: USER_LEVEL_ACCESS,
    'digital marketing': ADMIN_LEVEL_ACCESS,
    'general manager': ADMIN_LEVEL_ACCESS,
    'sales manager': ADMIN_LEVEL_ACCESS,
};

const validAddOnConversations = (route, user) => {
    if (
        route === '/conversations' &&
        !(
            user &&
            user.stores &&
            (isPluginAvailable(user.stores, WSP_PLUGIN) ||
                isPluginAvailable(user.stores, FB_PLUGIN) ||
                authorize(user?.accessLevel, DEVELOPER_LEVEL_ACCESS) ||
                (authorize(user?.accessLevel, GROUP_LEVEL_ACCESS) &&
                    user.group &&
                    (isPluginAvailable(user.group.stores, WSP_PLUGIN) ||
                        isPluginAvailable(user.group.stores, FB_PLUGIN))))
        )
    ) {
        return false;
    }
    return true;
};

const validAddOnCalls = (route, user) => {
    if (
        (route.includes('/management/recordings') ||
            route === '/create/recording') &&
        !(
            user &&
            user.stores &&
            (isPluginAvailable(user.stores, CALLS_PLUGIN) ||
                authorize(user?.accessLevel, DEVELOPER_LEVEL_ACCESS) ||
                (authorize(user?.accessLevel, GROUP_LEVEL_ACCESS) &&
                    user.group &&
                    isPluginAvailable(user.group.stores, CALLS_PLUGIN)))
        )
    ) {
        return false;
    }
    return true;
};

const validAddOnCampaigns = (route, user) => {
    if (
        (route.includes('/management/lists') ||
            route.includes('/management/campaigns') ||
            route === '/create/campaign' ||
            route === '/create/campaign') &&
        !(
            user &&
            user.stores &&
            (isPluginAvailable(user.stores, MAILING_PLUGIN) ||
                authorize(user?.accessLevel, DEVELOPER_LEVEL_ACCESS) ||
                (authorize(user?.accessLevel, GROUP_LEVEL_ACCESS) &&
                    user.group &&
                    isPluginAvailable(user.group.stores, MAILING_PLUGIN)))
        )
    ) {
        return false;
    }
    return true;
};

const validCreateVehicleUser = (route, user) => {
    if (
        route.includes('/create/vehicle') &&
        !authorize(user?.accessLevel, DEVELOPER_LEVEL_ACCESS)
    ) {
        return false;
    }
    return true;
};

const RolesGuard = ({ children, roles }) => {
    const { user } = useAuth();
    const history = useHistory();

    if (!localStorage.getItem('token')) history.push('/');

    useEffect(() => {
        if (user?.accessLevel) {
            if (roles) {
                let access = false;

                roles.map((item) => {
                    if (rolesArray[item] === user.accessLevel) {
                        access = true;
                    }
                    return false;
                });

                if (!access) {
                    history.push('/dashboards/general');
                }

                if (!validCreateVehicleUser(history.location.pathname, user))
                    history.push('/management/vehicles');

                if (!validAddOnConversations(history.location.pathname, user))
                    history.push('/dashboards/general');
                if (!validAddOnCalls(history.location.pathname, user))
                    history.push('/dashboards/general');
                if (!validAddOnCampaigns(history.location.pathname, user))
                    history.push('/dashboards/general');

                if (
                    authorize(
                        user?.accessLevel,
                        ADMIN_LEVEL_ACCESS,
                        USER_LEVEL_ACCESS
                    ) &&
                    history.location.pathname ===
                        '/management/showroom-leads' &&
                    user.areas &&
                    !user.areas.includes('showroom')
                )
                    history.push('/dashboards/general');
                if (
                    authorize(
                        user?.accessLevel,
                        ADMIN_LEVEL_ACCESS,
                        USER_LEVEL_ACCESS
                    ) &&
                    history.location.pathname === '/management/leads' &&
                    user.areas &&
                    !user.areas.includes('digital')
                )
                    history.push('/dashboards/general');
                if (
                    authorize(
                        user?.accessLevel,
                        ADMIN_LEVEL_ACCESS,
                        USER_LEVEL_ACCESS
                    ) &&
                    history.location.pathname === '/create/showroom-lead' &&
                    user.areas &&
                    !user.areas.includes('showroom')
                )
                    history.push('/dashboards/general');
                if (
                    authorize(
                        user?.accessLevel,
                        ADMIN_LEVEL_ACCESS,
                        USER_LEVEL_ACCESS
                    ) &&
                    history.location.pathname === '/create/lead' &&
                    user.areas &&
                    !user.areas.includes('digital')
                )
                    history.push('/dashboards/general');
            } else {
                history.push('/');
            }
        }
        //eslint-disable-next-line
    }, [user]);

    return <>{children}</>;
};

RolesGuard.propTypes = {
    children: PropTypes.node,
};

export default RolesGuard;
